import styled, { createGlobalStyle } from 'styled-components'

export const LoginAdminLayoutGlobalStyled = createGlobalStyle`
  
`

export const LoginAdminLayoutStyled = styled.div`
  * {
    font-family: Sarabun;
  }

  .content.login {
    margin-top: 100px;
    border: solid 1px #999;
    padding-bottom: 10px;

    .title-header {
      margin: 10px 0 0;
    }
    .title-second {
      margin: 0px 0 10px;
    }

    .title-header,
    .title-second {
      text-align: center;
      font-size: 20px;
      font-weight: bold;
    }

    .btn-login {
      background-color: #333;
      border: none;

      &:hover {
        background-color: #666;
      }
    }

    .versions {
      margin: 10px 0 0;
      .version {
        font-size: 13px;
      }
    }
  }
`
